import { useHandler } from "@redotech/react-util/hook";
import CheckIcon from "@redotech/redo-icons/check.svg";
import CopyIcon from "@redotech/redo-icons/copy-01.svg";
import { DiscountCodeMessageType } from "@redotech/redo-model/conversation/message-parsers/discount-bubble-message-parser";
import { memo, useState } from "react";
import { RedoButton } from "../../arbiter-components/buttons/redo-button";
import { RedoTextInput } from "../../arbiter-components/input/redo-text-input";
import { Flex } from "../../flex";
import * as css from "./discount-code-bubble.module.css";

const COPY_SUCCESS_DURATION_MS = 3000;

export const DiscountCodeBubble = memo(function DiscountCodeBubble({
  message,
  readOnly,
}: {
  message: DiscountCodeMessageType;
  readOnly: boolean;
}) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useHandler(async () => {
    await navigator.clipboard.writeText(
      message.structuredContent?.discountCode ?? "",
    );
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, COPY_SUCCESS_DURATION_MS);
  });

  return (
    <Flex
      align="flex-end"
      className={css.discountCodeBubbleContainer}
      dir="row"
      gap="md"
      px="lg"
      py="md"
    >
      <Flex dir="column" grow={1}>
        {/* This column was necessary because className on RedoTextInput is applied to a child of the input container */}
        <RedoTextInput
          className={css.discountCodeInput}
          label="Discount code"
          setValue={() => {}}
          state="disabled"
          value={message.structuredContent?.discountCode ?? ""}
        />
      </Flex>
      <RedoButton
        disabled={readOnly || copied}
        hierarchy="primary"
        IconLeading={copied ? CheckIcon : CopyIcon}
        onClick={handleCopy}
      />
    </Flex>
  );
});
